import { clamp as p } from "../../../utils/value/number.js";
function f(c, e, r, o) {
  if (e >= r) return 0;
  const t = o > 0 ? o : 1;
  if (t > r - e) return 0;
  const u = (Math.round((c - e) / t) * t + e - e) * 100 / (r - e);
  return Number(p(0, u, 100).toFixed(2));
}
export {
  f as calculateProgress
};
